import React, { useRef, useState, useEffect } from "react";
import Webcam from "react-webcam";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import "./style.scss";

const CameraRecorder = ({ payload, setPayload, attachmentType, onClose }) => {
  const webcamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [facingMode, setFacingMode] = useState("environment");
  const [recording, setRecording] = useState(false);
  const [timer, setTimer] = useState(0);

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    const fileImage = dataURLtoFile(imageSrc, "createPost.jpg");

    if (!payload.img) {
      setPayload({ ...payload, img: fileImage });
      onClose();
    } else {
      if (!payload.img2) {
        setPayload({ ...payload, img2: fileImage });
        onClose();
      } else {
        setPayload({ ...payload, img3: fileImage });
        onClose();
      }
    }
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const startRecording = () => {
    const options = { mimeType: "video/webm;codecs=vp9" };
    const mediaRecorder = new MediaRecorder(webcamRef.current.stream, options);
    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start();
    setRecording(true);
    setTimer(0);
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };

  const handleDataAvailable = (event) => {
    if (event.data.size > 0) {
      const blob = new Blob([event.data], { type: "video/mp4" });
      const fileVideo = new File([blob], "video.mp4");

      setPayload({ ...payload, video: fileVideo });
      onClose();
    }
  };

  const toggleFacingMode = () => {
    setFacingMode((prevFacingMode) =>
      prevFacingMode === "user" ? "environment" : "user"
    );
  };

  useEffect(() => {
    let interval;
    if (recording) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [recording]);

  return (
    <div className="webcam-capture-container">
      {attachmentType === "video" ? (
        <div className="webcam-capture">
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            className="webcam"
            videoConstraints={{ facingMode }}
          />
          <ListGroup className="list-group-capture-video">
            {recording ? (
              <ListGroupItem
                className="list-item-capture-video"
                onClick={stopRecording}
              >
                Stop Recording {timer} seconds
              </ListGroupItem>
            ) : (
              <ListGroupItem
                className="list-item-capture-video"
                onClick={startRecording}
              >
                Start Recording
              </ListGroupItem>
            )}
            <ListGroupItem
              className="list-item-capture-video"
              onClick={toggleFacingMode}
            >
              Switch Camera
            </ListGroupItem>
          </ListGroup>
        </div>
      ) : (
        <div className="webcam-capture">
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={{ facingMode }}
            className="webcam"
          />
          <ListGroup className="list-group-capture-camera">
            <ListGroupItem
              className="list-item-capture-camera"
              onClick={captureImage}
            >
              Capture Photo
            </ListGroupItem>
            <ListGroupItem
              className="list-item-capture-camera"
              onClick={toggleFacingMode}
            >
              Switch Camera
            </ListGroupItem>
          </ListGroup>
        </div>
      )}
    </div>
  );
};

export default CameraRecorder;
